/**
 * ClientHowConversationsStart Component
 * Section 7: How Conversations Start
 */

import React from 'react';
import { MessageSquare } from 'lucide-react';

export const ClientHowConversationsStart: React.FC = () => {
  const scrollToForm = () => {
    const element = document.getElementById('execution-fit-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const conversationPoints = [
    'How you work with leadership teams',
    'Where execution typically breaks down',
    'Whether execution infrastructure genuinely fits your approach'
  ];

  return (
    <section className="bg-stone-50 py-20 md:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">

          {/* Headline */}
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-stone-900 mb-12 leading-tight">
            No partner hype. No forced programs. Just execution fit.
          </h2>

          {/* Content */}
          <div className="space-y-8 text-lg md:text-xl text-stone-700 leading-relaxed">

            <p>
              We don't run affiliate schemes or push reseller models.
            </p>
            <p>
              We also don't try to fit OKR Hub into every consulting style.
            </p>

            <p className="pt-6 text-stone-900 font-medium">
              We start with a simple conversation:
            </p>

            {/* Conversation Points */}
            <ul className="space-y-4 ml-6">
              {conversationPoints.map((point, index) => (
                <li key={index} className="flex items-start">
                  <MessageSquare className="w-6 h-6 text-stone-900 mr-3 flex-shrink-0 mt-0.5" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>

            <p className="pt-6 text-stone-900 font-medium">
              If it doesn't, we'll say so.
            </p>

          </div>

          {/* CTA */}
          <div className="mt-12">
            <button
              onClick={scrollToForm}
              className="group inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white bg-stone-900 rounded-lg hover:bg-stone-800 transition-all duration-300 hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
            >
              Start a conversation about execution fit
            </button>
          </div>

        </div>
      </div>
    </section>
  );
};
